import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryProductGeneralDetailsResponse,
  IInventoryProductGeneralDetailsResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setProductCopyDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryProductCopyAPI = () => {
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  // const [productCopyDetails, setProductCopyDetails] = useState<IInventoryProductGeneralDetailsResponseData>(null);
  const execute = useCallback(
    async (productID: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${INVENTORY_MODULE?.PRODUCT_COPY_API?.baseURL}${productID}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryProductGeneralDetailsResponse>) => {
            if (res.data.status === true) {
              dispatch(setProductCopyDetails({ data: res.data.data }));
            } else {
              dispatch(setProductCopyDetails({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setProductCopyDetails({ data: null }));
            sendCurl(e.config["curlCommand"]);
            setProductCopyDetails(null);
            captureError(e)
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        dispatch(setProductCopyDetails({ data: null }));
      }
    },
    [dispatch],
  );
  return { execute };
};
